export enum SEARCH_ACTION_TYPES {
  SEARCH = 'SEARCH',
  SEARCHING = 'SEARCHING',
  SEARCH_SUCCESS = 'SEARCH_SUCCESS',
  SEARCH_FAILURE = 'SEARCH_FAILURE',
  CLEAR_SEARCH = 'CLEAR_SEARCH',
}
